import { render, staticRenderFns } from "./PropertyEditDialog.vue?vue&type=template&id=2b8ff376&scoped=true"
import script from "./PropertyEditDialog.vue?vue&type=script&lang=js"
export * from "./PropertyEditDialog.vue?vue&type=script&lang=js"
import style0 from "./PropertyEditDialog.vue?vue&type=style&index=0&id=2b8ff376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ff376",
  null
  
)

export default component.exports